<template lang="pug">
	div
		v-e24-nav-bar
		SectionTitle(isAccordions='true', :srcImage='imgHeader', :tall="tall", h1="My account")
		.main-container
			.child-container
				.my-account(v-if="dataReady")
					b-tabs(content-class="mt-3" fill)
						b-tab(title="Account Info" active)
							.tab-container
								.forms
									.side
										.field-title First Name
										.each-field-contact: b-form-input.all-fields(v-model="contact.name.first")
										.field-title Last Name
										.each-field-contact: b-form-input.all-fields(v-model="contact.name.last")
										.field-title Username
										.each-field-contact: b-form-input.all-fields(v-model="user.username", :disabled="true")
										.field-title email
										.each-field-contact: b-form-input.all-fields(v-model="contact.emailAddress().address")
										.phones
											span.title-phone: | Work phone
											.each-phone
												.left-side
													.field-title Area code
													.each-field-contact: b-form-input.all-fields(v-model="workAreaCode")
												.right-side
													.field-title Number
													.each-field-contact: b-form-input.all-fields(v-model="contact.phoneNumber('WORK').number")
											span.title-phone: | Mobile phone
											.each-phone
												.left-side
													.field-title Area code
													.each-field-contact: b-form-input.all-fields(v-model="mobileAreaCode")
												.right-side
													.field-title Number
													.each-field-contact: b-form-input.all-fields(v-model="contact.phoneNumber('MOBILE').number")
									.side
										.field-title Address 1
										.each-field-contact: b-form-input.all-fields(v-model="contact.postalAddress().line1")
										.field-title Address 2
										.each-field-contact: b-form-input.all-fields(v-model="contact.postalAddress().line2")
										.field-title City
										.each-field-contact: b-form-input.all-fields(v-model="contact.postalAddress().cityText")
										.state-zip-row
											.left-side
												.field-title State
												.each-field-contact: b-form-select.select-field.all-fields(v-model="contact.postalAddress().stateText", :options="options")
											.right-side
												.field-title Zip Code
												.each-field-contact: b-form-input.all-fields(v-model="contact.postalAddress().postalCode")
								.button-save
									save-btn

						b-tab(title="Change Password" )
							.tab-container
								.forms
									.side
										.field-title Current Password
										.each-field-contact: b-form-input.all-fields(v-model="oldPass", type="password")
										.field-title New Password
										.each-field-contact: b-form-input.all-fields(v-model="newPass", type="password")
										.field-title Confirm
										.each-field-contact: b-form-input.all-fields(v-model="confPass", type="password")

									.side

								.button-save
									save-btn
		v-e24-footer(:build="build")
</template>

<script>
import SectionTitle from '@/common/components/sectionTitle.vue'
import imageHeader from '@/common/img/list-project.jpg'
import saveBtn from '@/common/components/saveBtn.vue'
import Vue from 'vue'
import _ from 'lodash'
import {PhoneNumber} from 'janux-people'
import {EventBus} from '@/common/event-bus'
import readBuild from '../../util/readBuild'

export default {
	name: 'my-account',
	components: {
		SectionTitle, saveBtn
	},
	data () {
		return {
			build: '',
			imgHeader: imageHeader,
			tall: 90,
			dataReady: false,
			user: null,
			contact: null,
			workAreaCode: '',
			mobileAreaCode: '',
			oldPass: '',
			newPass: '',
			confPass: '',
			options: [
				{ value: null, text: 'Please select an option' },
				{ value: 'Alabama', text: 'Alabama' },
				{ value: 'Alaska', text: 'Alaska' },
				{ value: 'Arizona', text: 'Arizona' },
				{ value: 'Arkansas', text: 'Arkansas' },
				{ value: 'California', text: 'California' },
				{ value: 'Colorado', text: 'Colorado' },
				{ value: 'Connecticut', text: 'Connecticut' },
				{ value: 'Delaware', text: 'Delaware' },
				{ value: 'Florida', text: 'Florida' },
				{ value: 'Georgia', text: 'Georgia' },
				{ value: 'Hawaii', text: 'Hawaii' },
				{ value: 'Idaho', text: 'Idaho' },
				{ value: 'Illinois', text: 'Illinois' },
				{ value: 'Indiana', text: 'Indiana' },
				{ value: 'Iowa', text: 'Iowa' },
				{ value: 'Kansas', text: 'Kansas' },
				{ value: 'Kentucky', text: 'Kentucky' },
				{ value: 'Louisiana', text: 'Louisiana' },
				{ value: 'Maine', text: 'Maine' },
				{ value: 'Maryland', text: 'Maryland' },
				{ value: 'Massachusetts', text: 'Massachusetts' },
				{ value: 'Michigan', text: 'Michigan' },
				{ value: 'Minnesota', text: 'Minnesota' },
				{ value: 'Mississippi', text: 'Mississippi' },
				{ value: 'Missouri', text: 'Missouri' },
				{ value: 'Montana', text: 'Montana' },
				{ value: 'Nebraska', text: 'Nebraska' },
				{ value: 'Nevada', text: 'Nevada' },
				{ value: 'New Hampshire', text: 'New Hampshire' },
				{ value: 'New Jersey', text: 'New Jersey' },
				{ value: 'New Mexico', text: 'New Mexico' },
				{ value: 'New York', text: 'New York' },
				{ value: 'North Carolina', text: 'North Carolina' },
				{ value: 'North Dakota', text: 'North Dakota' },
				{ value: 'Ohio', text: 'Ohio' },
				{ value: 'Oklahoma', text: 'Oklahoma' },
				{ value: 'Oregon', text: 'Oregon' },
				{ value: 'Pennsylvania', text: 'Pennsylvania' },
				{ value: 'Rhode Island', text: 'Rhode Island' },
				{ value: 'South Carolina', text: 'South Carolina' },
				{ value: 'South Dakota', text: 'South Dakota' },
				{ value: 'Tennessee', text: 'Tennessee' },
				{ value: 'Texas', text: 'Texas' },
				{ value: 'Utah', text: 'Utah' },
				{ value: 'Vermont', text: 'Vermont' },
				{ value: 'Virginia', text: 'Virginia' },
				{ value: 'Washington', text: 'Washington' },
				{ value: 'West Virginia', text: 'West Virginia' },
				{ value: 'Wisconsin', text: 'Wisconsin' },
				{ value: 'Wyoming', text: 'Wyoming' }
			]
		}
	},
	mixins: [readBuild],
	mounted () {
		this.build = this.getBuild()
	},
	methods: {
		save () {
			if (this.oldPass !== '' && this.newPass !== '') {
				if (this.newPass !== this.confPass) {
					this.$notify({
						group: 'app',
						type: 'error',
						title: 'Password mismatch',
						text: 'New password must match confirmation',
						duration: 5000
					})
					return
				} else {
					this.user.oldPass = this.oldPass
					this.user.password = this.newPass
				}
			}

			// Temp solution to ensure areaCode and countryCode setter is working
			if (!_.isNil(this.workAreaCode)) {
				this.contact.phoneNumber('WORK').areaCode = this.workAreaCode
			}
			if (!_.isNil(this.mobileAreaCode)) {
				this.contact.phoneNumber('MOBILE').areaCode = this.mobileAreaCode
			}

			this.user.contact = this.contact
			Vue.jnx.userService.saveOrUpdate(this.user).then(() => {
				console.log('User has been saved!')
				this.$notify({
					group: 'app',
					type: 'info',
					title: 'Account changes saved',
					text: 'Account info successfully updated',
					duration: 2000
				})
			})
		}
	},
	created () {
		const userId = Vue.e24.security.currentUser.userId
		Vue.jnx.userService.findById(userId).then((user) => {
			this.user = user
			this.user.password = ''
			this.contact = this.user.contact
			this.workAreaCode = this.contact.phoneNumber('WORK').areaCode

			if (_.isNil(this.contact.phoneNumber('MOBILE'))) {
				const aPhone = new PhoneNumber('')
				this.contact.setContactMethod('MOBILE', aPhone)
				console.log('adding phone', aPhone)
			} else {
				this.mobileAreaCode = this.contact.phoneNumber('MOBILE').areaCode
			}
			this.dataReady = true
		})

		// Adding listener for save button event
		EventBus.$on('saving-info', this.save)
	},
	beforeDestroy () {
		// Unregistering saving button listener
		EventBus.$off('saving-info', this.save)
	}
}
</script>



// WEBPACK FOOTER //
// src/app/my-account/my-account.vue